import { c as _c } from "react/compiler-runtime";
import { Chips, Separator, Slider } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { useState } from 'react';
import { isNumber, isString } from 'ramda-adjunct';
import { suffixTestId } from 'shared/web';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import { useSliderTicks } from '../../hooks/useSliderTicks';
import { EagFilterProps } from '../../types/EagFilterProps';
export type SliderFilterProps = EagFilterProps & {
  min: number;
  max: number;
  minOpen: boolean;
  maxOpen: boolean;
  unit: string | null;
  stepSize: number | null;
  steps: number[];
  markerSize: number | null;
  markers?: number[];
  decimalsAllowed: boolean;
  inputsVisible: boolean;
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function SliderFilter(props) {
  const $ = _c(29);
  const ticks = useSliderTicks(props.min, props.max, props.markerSize, props.markers);
  const midValue = (props.max + props.min) / 2;
  const model = props.value[FILTER_VALUE_KEY] as number | string | null;
  let t0;
  if ($[0] !== props) {
    t0 = newValue => {
      props.onChange({
        [FILTER_VALUE_KEY]: newValue
      });
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onModelChange = t0;
  let t1;
  if ($[2] !== onModelChange) {
    t1 = {
      setFilterValue: onModelChange,
      defaultValue: null
    };
    $[2] = onModelChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    onChipsChange
  } = useFilterOnChipsChange(t1);
  let t2;
  if ($[4] !== props.unit) {
    t2 = value => props.unit ? `${value} [${props.unit}]` : `${value}`;
    $[4] = props.unit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const valueFormatter = t2;
  let t3;
  if ($[6] !== model) {
    t3 = isString(model) ? [model] : null;
    $[6] = model;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const isQuickFilterValue = t3;
  const [localSliderValue, setLocalSliderValue] = useState(isNumber(model) ? model : midValue);
  let t4;
  if ($[8] !== onModelChange) {
    t4 = value_0 => {
      setLocalSliderValue(value_0);
      onModelChange(value_0);
    };
    $[8] = onModelChange;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onSliderValueChange = t4;
  let t5;
  if ($[10] !== isQuickFilterValue || $[11] !== onChipsChange || $[12] !== props) {
    t5 = props.quickFilters && props.quickFilters.length > 0 && <><HStack><Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId("slider-filter-quickFilters", props)} isDeselectable={true} /></HStack><Separator /></>;
    $[10] = isQuickFilterValue;
    $[11] = onChipsChange;
    $[12] = props;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = props.isDisabled;
  const t7 = props.min;
  const t8 = props.max;
  const t9 = props.stepSize ?? props.steps ?? 1;
  let t10;
  if ($[14] !== props) {
    t10 = suffixTestId("slider-filter", props);
    $[14] = props;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== localSliderValue || $[17] !== onSliderValueChange || $[18] !== props.isDisabled || $[19] !== props.max || $[20] !== props.min || $[21] !== t10 || $[22] !== t9 || $[23] !== ticks || $[24] !== valueFormatter) {
    t11 = <Slider isDisabled={t6} min={t7} max={t8} step={t9} value={localSliderValue} onChange={onSliderValueChange} formatValue={valueFormatter} ticks={ticks} onlyEdges={true} displayValue="auto" data-testid={t10} />;
    $[16] = localSliderValue;
    $[17] = onSliderValueChange;
    $[18] = props.isDisabled;
    $[19] = props.max;
    $[20] = props.min;
    $[21] = t10;
    $[22] = t9;
    $[23] = ticks;
    $[24] = valueFormatter;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t5) {
    t12 = <VStack>{t5}{t11}</VStack>;
    $[26] = t11;
    $[27] = t5;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}